//Action creator with callback function
export function addLoyaltyRegistrationDetail(registrationDetails) {
    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: 'ADD_LOYALTY_REGISTRATION_DETAIL',
                payload: registrationDetails
            });
            resolve(true)
        });
    }
};

export const resetLoyaltyRegistrationDetail = () => ({
    type: 'RESET_LOYALTY_REGISTRATION_DETAIL'
});